var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { affiliateLinkConfirmationAction, updateAffiliateLinkAction, uploadAffiliatePhotoAction, removeProfileImageAction } from "../../reduxStore/actions/salesRepDataAction";
import store from "../../reduxStore/store";
import { isNullOrEmpty, useDeviceQueries } from "../../shared/Utilites";
import { isAPIServerError, isLoading } from "../../services/behaviorSubjectService";
import { SharedFunctions } from "../SharedFunctions";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
export var AffiliateLinkContactCardBL = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); }); // ** Get Data **
    var _p = SharedFunctions(), copyTextFunction = _p.copyTextFunction, useInfiniteScroll = _p.useInfiniteScroll;
    var repProfile = useSelector(function (state) { return state.salesRepData; });
    var profile = (_a = repProfile === null || repProfile === void 0 ? void 0 : repProfile.baseData) === null || _a === void 0 ? void 0 : _a.SingleSalesRep;
    var CheckPopUpInitialValue = (_d = (_c = (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.baseData) === null || _b === void 0 ? void 0 : _b.ConfirmationPopUpStatus) === null || _c === void 0 ? void 0 : _c.isAffiliatePopUpVisible) !== null && _d !== void 0 ? _d : false;
    var imageState = {
        isLoading: false,
        imageName: "",
        imagePreview: !isNullOrEmpty(profile === null || profile === void 0 ? void 0 : profile.ProfileImagePath) ? profile === null || profile === void 0 ? void 0 : profile.ProfileImagePath : "",
        imageSize: 0,
    };
    var _q = useState(profile ? profile === null || profile === void 0 ? void 0 : profile.Bio : ""), bio = _q[0], setBio = _q[1];
    var charMaxLength = 100;
    var _r = useState(bio && (bio === null || bio === void 0 ? void 0 : bio.length) < 100 ? charMaxLength - (bio === null || bio === void 0 ? void 0 : bio.length) : 0), contactCardCharLength = _r[0], setContactCardCharLength = _r[1];
    var productsData = repProfile.productsData, baseData = repProfile.baseData;
    var commissionOn = (_e = baseData === null || baseData === void 0 ? void 0 : baseData.CommissionDiscountOn) === null || _e === void 0 ? void 0 : _e.CommissionDiscountOn;
    var shopName = (_f = baseData === null || baseData === void 0 ? void 0 : baseData.ShopDomainName) !== null && _f !== void 0 ? _f : baseData === null || baseData === void 0 ? void 0 : baseData.ShopName;
    var _s = useState(false), affiliateIsConfirmOpen = _s[0], setAffiliateIsConfirmOpen = _s[1];
    var _t = useState(0), selectedProductIndex = _t[0], setSelectedProductIndex = _t[1];
    var _u = useState(""), selectedProductLink = _u[0], setSelectedProductLink = _u[1];
    var _v = useState({ msg: "", open: false, severity: "error" }), affiliateAlertMsg = _v[0], setAffiliateAlertMsg = _v[1];
    var productsContent = [];
    useEffect(function () {
        if ((productsData === null || productsData === void 0 ? void 0 : productsData.length) > 0) {
            isLoading.next(false);
        }
    }, [productsData]);
    var productTableColumns = [
        {
            id: "product",
            headerName: t("viewProductModelColumn1"),
            hide: false,
        },
        {
            id: "product_title",
            headerName: t("affiliateLink_searchColumn2"),
            hide: false,
        },
        {
            id: "price",
            headerName: t("affiliateLink_searchColumn3"),
            hide: false,
        },
        {
            id: "commission",
            headerName: t("affliateOrder_column6"),
            hide: commissionOn !== "Product",
        },
        {
            id: "affiliate_link",
            headerName: t("affiliate_product_link"),
            hide: false,
        },
        {
            id: "copy_link",
            headerName: t("affiliateLink_searchColumn7"),
            hide: false,
        },
        {
            id: "share_link",
            headerName: t("affiliateCartProdtableColumn6"),
            hide: false,
        },
    ];
    function getProductTable(productsData) {
        var tableArray = [];
        for (var _i = 0, productsData_1 = productsData; _i < productsData_1.length; _i++) {
            var _a = productsData_1[_i], productTitle = _a.productTitle, variants = _a.variants, productImages = _a.productImages, product_type = _a.product_type, handle = _a.handle;
            var url = affiliateUrl(shopName, handle);
            if ((variants === null || variants === void 0 ? void 0 : variants.length) > 0) {
                for (var _b = 0, variants_1 = variants; _b < variants_1.length; _b++) {
                    var _c = variants_1[_b], variantPrice = _c.variantPrice, image_id = _c.image_id, variantId = _c.variantId, variantTitle = _c.variantTitle, sku = _c.sku;
                    var src = getProductImages(productImages, image_id);
                    var commission = commissionPerProduct(product_type, variantId) || 0;
                    tableArray.push({
                        src: src,
                        productTitle: productTitle,
                        variantPrice: variantPrice,
                        commission: commission,
                        handle: handle,
                        url: url,
                        variantId: variantId,
                        variantTitle: variantTitle,
                        sku: sku,
                    });
                }
            }
            else {
                return tableArray;
            }
        }
        return tableArray;
    }
    function getProductImages(productImages, image_id) {
        var _a;
        var src = (_a = productImages[0]) === null || _a === void 0 ? void 0 : _a.src;
        for (var _i = 0, productImages_1 = productImages; _i < productImages_1.length; _i++) {
            var _b = productImages_1[_i], imageId = _b.imageId, src_1 = _b.src;
            src_1 = imageId === image_id ? src_1 : null;
        }
        return src;
    }
    function commissionPerProduct(product_type, variant_id) {
        var _a;
        var affiliateCommission = baseData === null || baseData === void 0 ? void 0 : baseData.CommissionandDiscountPerProductType;
        var affiliateCommissionPerProduct = baseData === null || baseData === void 0 ? void 0 : baseData.AffiliateCommissionPerProduct;
        var affiliateCommissionPerRepModel = baseData === null || baseData === void 0 ? void 0 : baseData.AffiliateCommissionPerRepModel;
        var customerId = (_a = repProfile === null || repProfile === void 0 ? void 0 : repProfile.loggedInRepDetails) === null || _a === void 0 ? void 0 : _a.customerId.toString();
        switch (commissionOn) {
            case "ProductType":
                if (!isNullOrEmpty(affiliateCommission)) {
                    for (var _i = 0, affiliateCommission_1 = affiliateCommission; _i < affiliateCommission_1.length; _i++) {
                        var _b = affiliateCommission_1[_i], productType = _b.productType, AffiliateCommission = _b.AffiliateCommission;
                        if (product_type.toLowerCase() === productType.toLowerCase()) {
                            return AffiliateCommission;
                        }
                    }
                }
                else {
                    return 0;
                }
                break;
            case "Product":
                if (!isNullOrEmpty(affiliateCommissionPerProduct)) {
                    for (var _c = 0, affiliateCommissionPerProduct_1 = affiliateCommissionPerProduct; _c < affiliateCommissionPerProduct_1.length; _c++) {
                        var _d = affiliateCommissionPerProduct_1[_c], variantId = _d.variantId, Commission = _d.Commission;
                        if (variant_id === variantId) {
                            return Commission * 100;
                        }
                    }
                }
                else {
                    return 0;
                }
                break;
            case "SalesRep":
                if (!isNullOrEmpty(affiliateCommissionPerRepModel)) {
                    for (var _e = 0, affiliateCommissionPerRepModel_1 = affiliateCommissionPerRepModel; _e < affiliateCommissionPerRepModel_1.length; _e++) {
                        var _f = affiliateCommissionPerRepModel_1[_e], SalesRepId = _f.SalesRepId, Commission = _f.Commission;
                        if (customerId === SalesRepId) {
                            return Commission;
                        }
                    }
                }
                else {
                    return 0;
                }
                break;
            default:
                return 0;
        }
    }
    function affiliateUrl(shopName, handle) {
        var _a, _b, _c;
        var queryString = !isNullOrEmpty((_a = baseData === null || baseData === void 0 ? void 0 : baseData.SingleSalesRep) === null || _a === void 0 ? void 0 : _a.SalesRepAffiliateUrl) ? (_c = (_b = baseData.SingleSalesRep) === null || _b === void 0 ? void 0 : _b.SalesRepAffiliateUrl) === null || _c === void 0 ? void 0 : _c.split("?")[1] : "ambassador=";
        var urlParams = new URLSearchParams(queryString);
        var ambassador = urlParams.get("ambassador");
        var url = "https://" + shopName + "/products/" + handle + "/?ambassador=" + ambassador;
        return url ? url : "https://" + shopName;
    }
    productsContent = getProductTable(productsData);
    function displaySnackbarErrMsg() {
        isAPIServerError.next(true);
    }
    // ================ AFFILIATE LINK CARD AND BIO =============================
    var uploadInputImage = useRef(null);
    var _w = useState(""), helperImage = _w[0], setHelperImageText = _w[1];
    var _x = useState(false), imageError = _x[0], setImageError = _x[1];
    var _y = useState(false), isImageInput = _y[0], setIsImageInput = _y[1];
    var _z = useState(), file = _z[0], setProfile = _z[1];
    var _0 = useState(false), showNewImage = _0[0], setShowNewImage = _0[1];
    var _1 = useState(imageState), image = _1[0], setImage = _1[1];
    var _2 = useState(t("yourBio_button2")), uploadImageState = _2[0], setUploadImageState = _2[1];
    var _3 = useState(false), imageLoading = _3[0], setImageLoading = _3[1];
    var _4 = useState(""), linkText = _4[0], setLinkText = _4[1];
    var _5 = useState(false), linkError = _5[0], setLinkError = _5[1];
    var _6 = useState(t("yourBio_button3")), saveState = _6[0], setSaveState = _6[1];
    var _7 = useState(t("yourBio_button3")), cardSaveState = _7[0], setCardSaveState = _7[1];
    var _8 = useState(""), helperTextLink = _8[0], setHelperTextLink = _8[1];
    var _9 = useState(false), savingLinkBio = _9[0], setSavingLinkBio = _9[1];
    var _10 = useState(profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink), updatedLink = _10[0], setUpdatedLink = _10[1];
    var _11 = useState(true), saveBtn = _11[0], setSaveBtn = _11[1];
    var imagePreview = image.imagePreview;
    useEffect(function () {
        setSaveState(t("yourBio_button3"));
        setCardSaveState(t("yourBio_button3"));
    }, [t]);
    var salesRepUniqueLink = (profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink) !== undefined && (profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink) !== null && (profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink) !== ""
        ? "https://" + shopName + "/" + linkText
        : (linkText === null || linkText === void 0 ? void 0 : linkText.length) > 0
            ? "https://" + shopName + "/" + linkText
            : "https://" + shopName + "/?" + ((_g = profile === null || profile === void 0 ? void 0 : profile.SalesRepAffiliateUrl) === null || _g === void 0 ? void 0 : _g.split("?")[1]);
    var handleUploadImage = function (_a) {
        var files = _a.target.files;
        return __awaiter(void 0, void 0, void 0, function () {
            var file;
            return __generator(this, function (_b) {
                setHelperImageText("");
                setImageError(false);
                file = files[0];
                if (!isNullOrEmpty(file)) {
                    if (file.size < 5000000) {
                        setImage(function (prevState) { return (__assign(__assign({}, prevState), { isLoading: true })); });
                        setProfile(file);
                        setShowNewImage(true);
                        setImage(function (prevState) { return (__assign(__assign({}, prevState), { imageName: file.name, imagePreview: URL.createObjectURL(file), imageSize: file.size, isLoading: false })); });
                    }
                    else {
                        setTimeout(function () {
                            setImageError(false);
                        }, 3000);
                        setImageError(true);
                        setHelperImageText(t("yourBio_error_image_size"));
                        setImage(imageState);
                        uploadInputImage.current.value = null;
                    }
                }
                else {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    var uploadImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var uploadPhotoStatus, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setUploadImageState(t("yourBio_Uploadbtn1"));
                    setImageLoading(true);
                    setHelperImageText("");
                    setImageError(false);
                    setIsImageInput(true);
                    if (!(!isNullOrEmpty(file) && image.imageSize < 5000000 && image.imagePreview !== "")) return [3 /*break*/, 3];
                    _a = file;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(uploadAffiliatePhotoAction(file))];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    uploadPhotoStatus = _a;
                    if (uploadPhotoStatus) {
                        setUploadImageState(t("yourBio_Uploadbtn2"));
                        setImage(function (prevState) { return (__assign(__assign({}, prevState), { isLoading: false })); });
                        setHelperImageText("");
                        setImageError(false);
                    }
                    else {
                        setImageError(true);
                        setImage(imageState);
                        uploadInputImage.current.value = null;
                        setUploadImageState(t("yourBio_button2"));
                        setHelperImageText(t("addCustomer_leadErrrorMsg"));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setHelperImageText(t("yourBio_error_image_size"));
                    setImageError(true);
                    setShowNewImage(false);
                    setImage(imageState);
                    uploadInputImage.current.value = null;
                    _b.label = 4;
                case 4:
                    setTimeout(function () {
                        setImageError(false);
                    }, 3000);
                    setShowNewImage(false);
                    setImageLoading(false);
                    setIsImageInput(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var linkTextValidation = function (e) {
        setLinkText(e.target.value);
        var regex = /^[A-Za-z0-9]+$/;
        if (e.target.value.trim() === "" || regex.test(e.target.value)) {
            setSaveBtn(false);
            setLinkError(false);
            setHelperTextLink("");
        }
        else {
            setSaveBtn(true);
            setLinkError(true);
            setHelperTextLink(t("affiliateLink_input_error_msg"));
        }
    };
    var bioTextValidation = function (e) {
        var _a;
        setContactCardCharLength(charMaxLength - ((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length));
        setBio(e.target.value);
        setSaveBtn(false);
    };
    var saveAffiliateInfo = function (saveFrom) { return __awaiter(void 0, void 0, void 0, function () {
        var isAffiliateCall, data, response, affiliateData, saveMsg, action, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (linkText === "" && (profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink) !== undefined && (profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink) !== null && (profile === null || profile === void 0 ? void 0 : profile.SalesRepUniqueLink) !== "") {
                        setLinkError(true);
                        setHelperTextLink(t("This field is required"));
                        return [2 /*return*/];
                    }
                    isAffiliateCall = saveFrom === "affiliateUrl" ? true : false;
                    setSavingLinkBio(true);
                    isAffiliateCall ? setSaveState(t("yourBio_Savebtn")) : setCardSaveState(t("yourBio_Savebtn")); // Saving
                    data = { uniquelink: linkText, bio: bio };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateAffiliateLinkAction(data)];
                case 2:
                    response = _a.sent();
                    setSavingLinkBio(false);
                    setSaveBtn(true);
                    if (response) {
                        affiliateData = __assign(__assign({}, store.getState().salesRepData.baseData.SingleSalesRep), { SalesRepUniqueLink: data.uniquelink, Bio: data.bio });
                        isAffiliateCall ? setSaveState(t("yourBio_button4")) : setCardSaveState(t("yourBio_button4")); // Saving
                        saveMsg = saveFrom === "affiliateUrl" ? t("yourBio_Linksuccessmsg") : t("Contact_Card_Bio_Save_Success_Msg");
                        setAffiliateAlertMsg({ msg: saveMsg, open: true, severity: "success" });
                        if (linkText === (affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.SalesRepUniqueLink) && bio === (affiliateData === null || affiliateData === void 0 ? void 0 : affiliateData.Bio)) {
                            setUpdatedLink(linkText);
                            setTimeout(function () {
                                isAffiliateCall ? setSaveState(t("yourBio_button3")) : setCardSaveState(t("yourBio_button3")); // Saving
                            }, 2000);
                        }
                        action = {
                            payload: affiliateData,
                            type: SalesRepDataActionType.UPDATE_SINGLE_SALES_REP,
                        };
                        dispatch(action);
                    }
                    else {
                        setAffiliateAlertMsg({ msg: t("yourBio_error_link"), open: true, severity: "error" });
                        isAffiliateCall ? setSaveState(t("yourBio_button3")) : setCardSaveState(t("yourBio_button3")); // Saving
                        setSaveBtn(false);
                        dispatch({
                            type: SalesRepDataActionType.UPDATE_SINGLE_SALES_REP,
                            payload: store.getState().salesRepData.baseData.SingleSalesRep,
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error updating affiliate link:", error_1);
                    setSavingLinkBio(false);
                    setSaveBtn(true);
                    setAffiliateAlertMsg({ msg: t("yourBio_error_link"), open: true, severity: "error" });
                    isAffiliateCall ? setSaveState(t("yourBio_button3")) : setCardSaveState(t("yourBio_button3")); // Saving
                    dispatch({
                        type: SalesRepDataActionType.UPDATE_SINGLE_SALES_REP,
                        payload: store.getState().salesRepData.baseData.SingleSalesRep,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ============ SEARCHPRODUCTTABLE  =============================
    var shopCurrency = (_j = (_h = store.getState().salesRepData) === null || _h === void 0 ? void 0 : _h.loggedInRepDetails) === null || _j === void 0 ? void 0 : _j.shopCurrency;
    var currency = (_l = (_k = store.getState().salesRepData) === null || _k === void 0 ? void 0 : _k.loggedInRepDetails) === null || _l === void 0 ? void 0 : _l.currency;
    var commissionDiscountType = (_o = (_m = repProfile === null || repProfile === void 0 ? void 0 : repProfile.baseData) === null || _m === void 0 ? void 0 : _m.CommissionDiscountOn) === null || _o === void 0 ? void 0 : _o.CommissionDiscountType;
    var _12 = useState(productsContent), products = _12[0], setProducts = _12[1];
    var _13 = useState(false), showTable = _13[0], setShowTable = _13[1];
    var _14 = useState(10), affiliateProductsRowsPerPage = _14[0], setAffiliateProductsRowsPerPage = _14[1];
    var affiliateInnerScroll = useInfiniteScroll(affiliateProductsRowsPerPage, setAffiliateProductsRowsPerPage, products);
    var searchProductTable = function (e) {
        setAffiliateProductsRowsPerPage(10);
        var searchText = e.target.value.trim().toLowerCase();
        searchText ? setShowTable(true) : setShowTable(false);
        var filteredRows = productsContent === null || productsContent === void 0 ? void 0 : productsContent.filter(function (product) {
            var _a, _b;
            var title = (_a = product.productTitle) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            var variantTitle = (_b = product.variantTitle) === null || _b === void 0 ? void 0 : _b.toLowerCase();
            return (title === null || title === void 0 ? void 0 : title.includes(searchText)) || (variantTitle === null || variantTitle === void 0 ? void 0 : variantTitle.includes(searchText));
        });
        setProducts(filteredRows);
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAffiliateAlertMsg({ msg: "", open: false });
    };
    var handleDoNotShowState = function (text, key) { return __awaiter(void 0, void 0, void 0, function () {
        var affiliatePopUpVisible, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading.next(true);
                    copyTextFunction(text, key);
                    affiliatePopUpVisible = true;
                    return [4 /*yield*/, dispatch(affiliateLinkConfirmationAction(affiliatePopUpVisible))];
                case 1:
                    response = _a.sent();
                    if (response) {
                        setAffiliateAlertMsg({ msg: t("copyLinkSuccess"), open: true, severity: "success" });
                    }
                    else {
                        setAffiliateAlertMsg({ msg: t("createOrderFromCartPage_Address_errorMsg5"), open: true, severity: "error" });
                    }
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var showToasterSuccessMsg = function () {
        setAffiliateAlertMsg({ msg: t("copyLinkSuccess"), open: true, severity: "success" });
    };
    var handleAffiliateOpenConfirm = function () {
        setAffiliateIsConfirmOpen(!affiliateIsConfirmOpen);
    };
    var removeContactCardImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var successremove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setImageLoading(true);
                    if (uploadInputImage.current)
                        uploadInputImage.current.value = "";
                    setShowNewImage(false);
                    return [4 /*yield*/, dispatch(removeProfileImageAction())];
                case 1:
                    successremove = _a.sent();
                    if (!successremove) {
                        setImageError(true);
                        setHelperImageText(t("Remove_Image_Error"));
                    }
                    else {
                        setImage(function (prev) { return (__assign(__assign({}, prev), { imagePreview: "", imageName: "", imageSize: 0 })); });
                    }
                    setImageLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        isImageInput: isImageInput,
        repProfile: repProfile,
        saveBtn: saveBtn,
        searchProductTable: searchProductTable,
        commissionDiscountType: commissionDiscountType,
        commissionOn: commissionOn,
        shopCurrency: shopCurrency,
        currency: currency,
        products: products,
        showTable: showTable,
        shopName: shopName,
        productsContent: productsContent,
        productTableColumns: productTableColumns,
        showNewImage: showNewImage,
        imagePreview: imagePreview,
        saveState: saveState,
        cardSaveState: cardSaveState,
        profile: profile,
        setBio: setBio,
        uploadInputImage: uploadInputImage,
        setLinkText: setLinkText,
        setImage: setImage,
        image: image,
        bio: bio,
        uploadImageState: uploadImageState,
        linkText: linkText,
        imageLoading: imageLoading,
        updatedLink: updatedLink,
        savingLinkBio: savingLinkBio,
        helperTextLink: helperTextLink,
        linkError: linkError,
        handleUploadImage: handleUploadImage,
        uploadImage: uploadImage,
        linkTextValidation: linkTextValidation,
        bioTextValidation: bioTextValidation,
        saveAffiliateInfo: saveAffiliateInfo,
        helperImage: helperImage,
        imageError: imageError,
        contactCardCharLength: contactCardCharLength,
        charMaxLength: charMaxLength,
        productsData: productsData,
        salesRepUniqueLink: salesRepUniqueLink,
        t: t,
        affiliateIsConfirmOpen: affiliateIsConfirmOpen,
        handleDoNotShowState: handleDoNotShowState,
        handleAffiliateOpenConfirm: handleAffiliateOpenConfirm,
        CheckPopUpInitialValue: CheckPopUpInitialValue,
        setSelectedProductIndex: setSelectedProductIndex,
        selectedProductIndex: selectedProductIndex,
        setSelectedProductLink: setSelectedProductLink,
        selectedProductLink: selectedProductLink,
        handleAlertMsgClose: handleAlertMsgClose,
        affiliateAlertMsg: affiliateAlertMsg,
        affiliateInnerScroll: affiliateInnerScroll,
        affiliateProductsRowsPerPage: affiliateProductsRowsPerPage,
        affiliateUrl: affiliateUrl,
        commissionPerProduct: commissionPerProduct,
        showToasterSuccessMsg: showToasterSuccessMsg,
        removeContactCardImage: removeContactCardImage,
    };
};
export function CssConstantObjects() {
    var isMobile = useDeviceQueries();
    var ST_CI_ContactCart = {
        width: isMobile ? "100% !important" : "95% !important",
        margin: "0 auto",
        display: "inline-flex",
    };
    var ST_CI_MediaCart = {
        padding: "1.5rem !important",
        backgroundColor: "white !important",
        overflow: "hidden !important",
    };
    var ST_CI_HorizontalLine = {
        marginBottom: "1rem",
        display: "inline-flex",
        width: "95%",
    };
    return { ST_CI_ContactCart: ST_CI_ContactCart, ST_CI_MediaCart: ST_CI_MediaCart, ST_CI_HorizontalLine: ST_CI_HorizontalLine, isMobile: isMobile };
}
